// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1x7ZG","image":"Header_image__3Xq5t","name":"Header_name__1pAEU","info":"Header_info__2nN4M","infoRow":"Header_infoRow__YywAG"};